<template>
    <add-new-business/>
</template>

<script>
import AddNewBusiness from '@/components/Businesses/add-new-business.vue'
export default {
    components: {
        AddNewBusiness
    },
}
</script>